"use client";

import { useEffect } from "react";
import { getPosts } from "@/lib/wordpress";
import { usePathname } from "next/navigation";
import { locales } from "@/config"; // Pastikan locale sudah diimport dari konfigurasi

export default function JsonLdScript() {
    const pathname = usePathname();

    // Menentukan locale berdasarkan pathname
    const locale =
        locales.find((loc) => pathname.startsWith(`/${loc}`)) || "en"; // Menyesuaikan locale berdasarkan path

    useEffect(() => {
        let isSubscribed = true; // Untuk mencegah memory leak

        async function fetchAndAddJsonLd() {
            try {
                // Sesuaikan URL base sesuai dengan locale
                const apiBaseUrl =
                    locale === "id"
                        ? "https://blog.mubarokah.com/id/wp-json/wp/v2"
                        : "https://blog.mubarokah.com/wp-json/wp/v2"; // Default untuk bahasa Inggris

                const baseUrl = process.env.NEXT_PUBLIC_APP_URL || "https://mubarokah.com";
                const posts = await getPosts("6", undefined, "posts", apiBaseUrl);

                if (!isSubscribed) return;

                if (!posts || posts.length === 0) {
                    console.log("No posts found");
                    return;
                }

                const jsonLd = {
                    "@context": "https://schema.org",
                    "@type": "Blog",
                    "url": `${baseUrl}/${locale}/posts`,
                    "name": "Mubarokah Digital Agency",
                    "description":
                        "The latest news and updates from Mubarokah Digital Agency, covering tips, insights, and the latest trends.",
                    "blogPost": posts.map((post: any) => {
                        const featuredMedia =
                            post?._embedded?.["wp:featuredmedia"]?.[0];
                        const imageUrl =
                            featuredMedia?.media_details?.sizes?.full?.source_url;

                        return {
                            "@type": "NewsArticle",
                            "headline": post.title.rendered,
                            "image": imageUrl || `${baseUrl}/default-blog-image.jpg`,
                            "datePublished": post.date_gmt,
                            "dateModified": post.modified_gmt,
                            "author": {
                                "@type": "Person",
                                "name": post._embedded?.author?.[0]?.name || "Mubarokah Team",
                            },
                            "description":
                                post.yoast_head_json?.description ||
                                "Stay updated with the latest news from Mubarokah Digital Agency.",
                            "url": `${baseUrl}/${locale}/posts/${post.slug}`,
                        };
                    }),
                };

                // Remove existing JSON-LD script if exists
                const existingScript = document.querySelector(
                    'script[data-type="blog-jsonld"]'
                );
                if (existingScript) {
                    existingScript.remove();
                }

                // Add new JSON-LD script
                const script = document.createElement("script");
                script.type = "application/ld+json";
                script.dataset.type = "blog-jsonld";
                script.text = JSON.stringify(jsonLd);
                document.head.appendChild(script);
            } catch (error) {
                console.error("Error creating JSON-LD:", error);
            }
        }

        fetchAndAddJsonLd();

        // Cleanup function
        return () => {
            isSubscribed = false;
            const script = document.querySelector('script[data-type="blog-jsonld"]');
            if (script) {
                script.remove();
            }
        };
    }, [locale]); // Tambahkan dependensi locale agar effect dipicu saat locale berubah

    return null;
}
